import ajax from '../http/ajax'

// 获取分销员商城数据
export const getDistributorMall = params => {
    return ajax.get('getDistributorMall', params)
}

// 获取分销员信息
export const getDistributorInfo = params => {
    return ajax.get('getDistributorInfo', params)
}
